// Ozlo Sold Ticker
// Extracted from ozlo-main.js
// Animated counter showing items sold (with cookie persistence)

function initSoldTicker() {
  const ticker = document.querySelector('span[data-sold-ticker]');

  if (!ticker) return;

  // Helper to parse number from formatted string
  const parseNumber = (str) => {
    return parseInt(str.replace(/,/g, ''), 10) || 0;
  };

  // Helper to format number with commas
  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  // Get cookie value
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
  };

  // Set cookie value
  const setCookie = (name, value, days = 1) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/`;
  };

  // Get initial value from cookie or data attribute
  const cookieValue = getCookie('soldTickerValue');
  const initialValue = cookieValue
    ? parseNumber(cookieValue)
    : parseNumber(ticker.getAttribute('data-ticker-initial-value')) || 0;

  // Calculate target value
  const increment = parseInt(ticker.getAttribute('data-sold-ticker'), 10) || 0;
  const targetValue = initialValue + increment;

  // Current display value
  let currentValue = initialValue;

  // Animation function
  const animate = () => {
    const displayedValue = parseNumber(ticker.textContent);

    if (displayedValue < targetValue) {
      // Fade out
      ticker.classList.add('fade-out');

      setTimeout(() => {
        // Increment value
        const newValue = displayedValue + 1;
        ticker.textContent = formatNumber(newValue);

        // Save to cookie
        setCookie('soldTickerValue', newValue);

        // Fade in
        ticker.classList.remove('fade-out');
        ticker.classList.add('fade-in');

        setTimeout(() => {
          ticker.classList.remove('fade-in');
        }, 500);
      }, 250);

      // Schedule next increment (random delay between 10-20 seconds)
      const randomDelay = (Math.random() * 10000) + 10000;
      setTimeout(animate, randomDelay);
    }
  };

  // Set initial display
  ticker.textContent = formatNumber(initialValue);

  // Start animation
  animate();
}

// Initialize on page load
window.addEventListener('load', initSoldTicker);
